import { useEffect, useRef } from 'react'
import { cn } from '@/lib/utils'
import { withAnonymousImages } from '../mailCompose'

/** Renders HTML mail body without dangerouslySetInnerHTML (sandboxed iframe). */
export function MailBodyView({
  html,
  className,
  tone = 'default',
}: {
  html: string
  className?: string
  tone?: 'default' | 'onPrimary'
}) {
  const ref = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    const frame = ref.current
    if (!frame) return
    const doc = frame.contentDocument
    if (!doc) return
    const styles = getComputedStyle(document.documentElement)
    const fg =
      tone === 'onPrimary'
        ? styles.getPropertyValue('--primary-foreground').trim() || '0.985 0 0'
        : styles.getPropertyValue('--foreground').trim() || '0.21 0.02 265'
    const bg = tone === 'onPrimary' ? null : styles.getPropertyValue('--card').trim() || '1 0 0'
    const muted =
      tone === 'onPrimary'
        ? styles.getPropertyValue('--primary-foreground').trim() || '0.985 0 0'
        : styles.getPropertyValue('--muted-foreground').trim() || '0.52 0.02 265'
    const border = styles.getPropertyValue('--border').trim() || '0.92 0.006 265'
    const body = withAnonymousImages(html)
    doc.open()
    doc.write(`<!DOCTYPE html><html><head><meta charset="utf-8"/><meta name="referrer" content="no-referrer"/><base target="_blank"/><style>
      html,body{margin:0;padding:0;background:${bg ? `oklch(${bg})` : 'transparent'};color:oklch(${fg});
        font:14px/1.55 system-ui,-apple-system,sans-serif;word-break:break-word}
      a{color:inherit;text-decoration:underline}
      blockquote{border-left:2px solid oklch(${border});padding-left:0.75rem;margin:0.5rem 0;color:oklch(${muted})}
      img{max-width:100%;height:auto}
      p{margin:0 0 0.75em}
    </style></head><body>${body}</body></html>`)
    doc.close()
    const resize = () => {
      if (!frame.contentDocument?.body) return
      frame.style.height = `${Math.max(frame.contentDocument.body.scrollHeight + 24, tone === 'onPrimary' ? 24 : 80)}px`
    }
    resize()
    const obs = new ResizeObserver(resize)
    if (frame.contentDocument.body) obs.observe(frame.contentDocument.body)
    return () => obs.disconnect()
  }, [html, tone])

  return (
    <iframe
      ref={ref}
      title="mail-body"
      referrerPolicy="no-referrer"
      // allow-same-origin: gövde contentDocument'e yazılır ve yükseklik ölçülür (boş sandbox'ta contentDocument null olur, mail boş görünür).
      // allow-scripts verilmez; mail içindeki betikler çalışmaz. Bağlantılar yeni sekmede açılır.
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      className={cn('w-full border-0 bg-transparent', className)}
    />
  )
}
